module.exports = __webpack_public_path__ + "img/ic_float_service.4129e745.png";